import React from 'react';
import axios from 'axios';
import FixedPeriodGrid from './FixedPeriodGrid';
import CustomPeriodControl from './CustomPeriodControl';
import IndexSection from './IndexSection';
import Loader from 'react-loader';
import { connect } from 'react-redux';
import FaQuestionCircle from 'react-icons/lib/fa/question-circle';
import * as utils from '../util';
import * as _ from "underscore";
import Toggle from './Toggle.js'

import {
  LAST_FIXING_DATE,
  LAST_BOE_DATE
} from '../constants/actionTypes';
import pdfFile from '../static/RealisedRateTermsAndConditions.pdf';

const mapStateToProps = state => ({
  ...state.common,
  fbToken: state.common.fbToken
});

const mapDispatchToProps = dispatch => {
  return {
    lastFixingDateLoaded: (date) => dispatch({ type: LAST_FIXING_DATE, payload: date }),
    lastBoeDateLoaded: (date) => dispatch({ type: LAST_BOE_DATE, payload: date })
  }
};
let sourceToken;
let sourceTokenRR = {};
let sourceTokenLag = {};
let GA_OBJECTS_DIMENSIONS;

class User extends React.Component {
  constructor(props) {
    super(props);
    
    this.initialStates = this.loadInitialStates();
    this.initialStates['instrumentType'] = props.tabName;
    this.state = this.initialStates;
    GA_OBJECTS_DIMENSIONS = utils.getGaObjectsDimension(this.state.instrumentType);
  }

  loadInitialStates(){
    return {
      startDate: null,
      endDate: null,
      startDateCustom: null,
      endDateCustom: null,
      endDateIndex: null,
      maxDate15: null,
      maxDate5: null,
      fallbackMaxDate: null,
      fallbackMinDate: null,
      lastFixingDate: null,
      lag: "5d",
      lagCus: "5d",
      roundCus: 4,
      holidays: 'LDN - London',
      spreadCustom: '',
      floorLvl: '',
      notionalCustom: '',
      outputVal: _.clone(utils.loadArr),
      outputVal2: _.clone(utils.loadArr),
      fallbackVal: _.clone(utils.loadArr),
      index: _.clone(utils.indexArr),
      outputValCustom: null,
      couponCustom: null,
      isBoeLoaded: false,
      isGridOneError: _.clone(utils.loadArr),
      isGridTwoError: false,
      isGridOneRealRateError: _.clone(utils.loadArr),
      isGridOneFallbackRateError: _.clone(utils.loadArr),
      isLoadIndexError: false,
      loadingFirstGrid: _.clone(utils.loadArrFalse),
      loadingSecondGrid: false,
      loadingFirstGridRealRate: _.clone(utils.loadArrFalse),
      loadingFirstGridFallbackRate: _.clone(utils.loadArrFalse),
      isAlertOpen: false,
      loadingIndex: false,
      showAdvanceOptions: false,
      loadingSecondRateGrid: false,
      isRateChange: false,
      dayCount: '',
      defaultDayCount: '',
      endDateAdjustment: '',
      defaultEndDateAdjustment: '',
      roundingRule: '',
      defaultRoundingRule: '',
      currency: '',
      selectedHolidays: [],
      resetType: '',
      defaultResetType: '',
      lagOptions: [],
      roundOptions: [],
      holidayCalendarsOptions: [],
      dayCountOptions: [],
      endDateAdjustmentOptions: [],
      roundingRuleOptions: [],
      resetTypeOptions: [],
      availableLastFixingDate: '',
      calcDate: null,
      fallbackToggle: false,
      todaysFallbackDate: 'N/A',
      matches: window.matchMedia("(min-width: 768px)").matches,
      negativeInterestRateTypes: [],
      defaultNegativeInterestRateType: '',
      negativeInterestType: ''
    }
  }


  componentDidMount() {

    const handler = e => this.setState({ matches: e.matches });
    let matched = window.matchMedia("(min-width: 768px)");
    // below listner works for both IE  and chrome
    matched.addListener((handler));
    // matched.addListener("change", (handler));
    // matched.addEventListener("change", (handler));

    this.getBoeCurrentDate();
    if (utils.isGaCookieEnabled()) {
      window.gtag('config', utils.GA_TRACKING_ID, {
        'custom_map': {
          'dimension1': GA_OBJECTS_DIMENSIONS.stdEndDate, 'dimension2': GA_OBJECTS_DIMENSIONS.stdLag, 'dimension3': GA_OBJECTS_DIMENSIONS.calcStartDate,
          'dimension4': GA_OBJECTS_DIMENSIONS.calcEndDate, 'dimension5': GA_OBJECTS_DIMENSIONS.calcLag, 'dimension6': GA_OBJECTS_DIMENSIONS.calcRounding, 'dimension7': GA_OBJECTS_DIMENSIONS.indexDate
        }
      });

      window.gtag('event', this.state.instrumentType + ' index page loaded');
    }
  }

  getHeaderWithToken() {
    if (this.props.isFirebaseEnabled && this.state.instrumentType == 'SONIA' && this.props.fbToken != null) {
      return { "headers": { "USER-ID-TOKEN": this.props.fbToken } }
    }
  }

  loadInitialData = () => {
    const urls = []
    if (this.state.fallbackToggle == false) {
      urls.push(...utils.periods.map(item => {
        return utils.createGridOneUrl(this.state.instrumentType, this.state.endDate, item, 0, this.state.defaultResetType);
      }));
    } else {
      urls.push(utils.periods.map(item => {
        return utils.createGridOneFallbackUrl(this.state.instrumentType, this.state.calcDate, item);
      }));
    }
    urls.push(...utils.periods.map(item => {
      return utils.createGridOneUrl(this.state.instrumentType, this.state.endDate, item, this.state.lag, this.state.defaultResetType);
    }));
    urls.push(utils.createCustomFilterUrl(this.state.instrumentType, this.state.startDateCustom, this.state.endDateCustom, this.state.roundCus, this.state.lagCus, this.state.notionalCustom,
      this.state.spreadCustom, this.state.dayCount, this.state.endDateAdjustment, this.state.roundingRule, this.state.selectedHolidays, this.state.resetType, this.state.defaultEndDateAdjustment, this.state.defaultDayCount, this.state.defaultRoundingRule, this.state.defaultResetType, this.state.negativeInterestType, this.state.floorLvl));
    urls.push(...utils.indexPeriods.map(item => {
      return utils.createIndexRateUrl(this.state.instrumentType, this.state.endDateIndex, item);
    }));

    const promises = urls.map(item => {
      return axios.get(item, this.getHeaderWithToken());
    });

    return Promise.all(promises).then(resArray => {
      let outputVal2 = {};
      let outputVal = {};
      let outputValCustom = null;
      let index = {};
      const countPeriods = utils.periods.length;
      resArray.forEach((item, i) => {
        if (i < countPeriods) {
          outputVal2[utils.periods[i]] = item.data;
        }
        else if (i >= countPeriods && i < 2 * countPeriods) {
          outputVal[utils.periods[i - countPeriods]] = item.data;
        }
        else if (i === 2 * countPeriods) {
          outputValCustom = item.data;
        }
        else {
          index[i === 2 * countPeriods + 1 ? '0D' : '5D'] = item.data;
        }
      });
      this.setState({ outputVal2, outputVal, outputValCustom, index, isBoeLoaded: true });
    }).catch(err => {
      this.setState({ isGridOneRealRateError: true, isGridOneFallbackRateError: true, isGridOneError: true, isGridTwoError: true, isLoadIndexError: true, isBoeLoaded: true })
    });
  }

  getBoeCurrentDate = () => {
    var currentDateUrl = utils.createBoeUrl(this.state.instrumentType);

    axios.get(currentDateUrl, this.getHeaderWithToken()).then(res => {
      var endDate = utils.customDateDdMmmYyyy(res.data.latest_boe_date);
      var maxDate5 = utils.customDateDdMmmYyyy(res.data.latest_boe_date_plus_five);
      var maxDate15 = utils.customDateDdMmmYyyy(res.data.latest_boe_date_plus_fifteen);
      var lastFixingDate = utils.customDateDdMmmYyyy(res.data.last_fixing_date);
      var availableLastFixingDate = utils.customDateDdMmmYyyy(res.data.available_last_fixing_date);

      //Fallback Dates
      var maxFallbackDate = utils.customDateDdMmmYyyy(res.data.fallback_calendar_params.upper_range_date);
      var minFallbackDate = utils.customDateDdMmmYyyy(res.data.fallback_calendar_params.lower_range_date);
      var defaultFallbackDate = utils.customDateDdMmmYyyy(res.data.fallback_calendar_params.default_date);
      // var defaultFallbackDate=utils.customDateDdMmmYyyy("20/Oct/2020"); 
      //Fallback Dates

      var startDateCus = utils.customDateDdMmmYyyy(res.data.latest_boe_date);
      startDateCus = new Date(startDateCus.setMonth(startDateCus.getMonth() - 3));
      this.props.lastFixingDateLoaded(lastFixingDate);
      this.props.lastBoeDateLoaded(res.data.latest_boe_date);

      var defaultLag = res.data.default_lag;
      var defaultRound = res.data.default_round;
      var defaultDayCount = res.data.default_day_count;
      var defaultHolidayCalendar = res.data.default_holiday_calendar;
      var defaultEndDateAdjustment = res.data.default_end_date_adjustment;
      var defaultRoundingRule = res.data.default_rounding_rule;
      var defaultResetType = res.data.default_reset_type;
      var lagList = res.data.lag;
      var roundList = res.data.round;
      var dayCountList = res.data.day_count;
      var endDateAdjustmentList = res.data.end_date_adjustment;
      var roundingRuleList = res.data.rounding_rule;
      var holidayCalendarList = res.data.calendar;
      var resetTypeList = res.data.reset_type;
      var currency = res.data.default_currency;
      var negativeInterestRateTypes = res.data.negative_interest_rate_types;
      var defaultNegativeInterestRateType = res.data.default_negative_interest_rate_type;

      const selectedHolidays = [...this.state.selectedHolidays];
      selectedHolidays.push(defaultHolidayCalendar.substring(0, 3));

      this.setState({
        endDate: endDate,
        endDateCustom: endDate,
        endDateIndex: endDate,
        startDateCustom: startDateCus,
        maxDate5,
        maxDate15,
        lag: defaultLag,
        lagCus: defaultLag,
        roundCus: defaultRound,
        holidays: defaultHolidayCalendar,
        selectedHolidays: selectedHolidays,
        roundingRule: defaultRoundingRule,
        defaultRoundingRule: defaultRoundingRule,
        endDateAdjustment: defaultEndDateAdjustment,
        defaultEndDateAdjustment: defaultEndDateAdjustment,
        dayCountOptions: dayCountList,
        endDateAdjustmentOptions: endDateAdjustmentList,
        roundingRuleOptions: roundingRuleList,
        dayCount: defaultDayCount,
        defaultDayCount: defaultDayCount, defaultDayCount: defaultDayCount,
        holidayCalendarsOptions: holidayCalendarList,
        roundOptions: roundList,
        lagOptions: lagList,
        currency: currency,
        lastFixingDate: lastFixingDate,
        defaultResetType: defaultResetType,
        resetType: defaultResetType,
        resetTypeOptions: resetTypeList,
        availableLastFixingDate: availableLastFixingDate,
        fallbackMaxDate: maxFallbackDate,
        fallbackMinDate: minFallbackDate,
        calcDate: defaultFallbackDate,
        defaultNegativeInterestRateType,
        negativeInterestRateTypes,
        negativeInterestType: defaultNegativeInterestRateType
      },
        () => { this.loadInitialData() });
    }).catch(err => {
      this.setState({ isGridTwoError: true, loadingSecondGrid: false, loadingSecondRateGrid: false, isRateChange: false })
    });
  }
  handleDateChange = (value) => {
    utils.sendGaAnalyticsEvent(GA_OBJECTS_DIMENSIONS.stdEndDate, utils.formatDateDDMMYYY(value));
    this.setState({ endDate: new Date(value) }, function () {
      this.getGridOneCalcs(false);
      if (this.state.fallbackToggle == false) {
        this.getGridOneCalcs(true);
      }
    })
  }
  handleFallbackDateChange = (value) => {
    utils.sendGaAnalyticsEvent(GA_OBJECTS_DIMENSIONS.stdEndDate, utils.formatDateDDMMYYY(value));
    this.setState({ calcDate: new Date(value) }, function () {
      this.getGridOneFallbackCalcs();
    })
  }
  handleFallbackToggle = (toggle) => {
    this.setState({ fallbackToggle: toggle.target.checked }, function (isChecked) {
      if (this.state.fallbackToggle) {
        this.handleFallbackDateChange(this.state.calcDate);
      } else {
        this.handleDateChange(this.state.endDate);
      }
    })
  }
  handleLagChange = (value) => {
    utils.sendGaAnalyticsEvent(GA_OBJECTS_DIMENSIONS.stdLag, utils.parseLag(value));
    this.setState({ lag: value }, () => {
      this.getGridOneCalcs(false);
    })
  }
  handleStartDateCusChange = (value) => {
    utils.sendGaAnalyticsEvent(GA_OBJECTS_DIMENSIONS.calcStartDate, utils.formatDateDDMMYYY(value));
    this.setState({ startDateCustom: new Date(value) }, () => {
      this.getCusGridCalculations();
    });
  }
  handleEndDateCusChange = (value) => {
    utils.sendGaAnalyticsEvent(GA_OBJECTS_DIMENSIONS.calcEndDate, utils.formatDateDDMMYYY(value));
    this.setState({ endDateCustom: new Date(value), isRateChange: true }, () => {
      this.getCusGridCalculations();
    });
  }
  handleLagCusChange = (value) => {
    utils.sendGaAnalyticsEvent(GA_OBJECTS_DIMENSIONS.calcLag, utils.parseLag(value));
    this.setState({ lagCus: value, isRateChange: true }, () => {
      this.getCusGridCalculations();
    })
  }
  handleRoundCusChange = (value) => {
    utils.sendGaAnalyticsEvent(GA_OBJECTS_DIMENSIONS.calcRounding, value);
    this.setState({ roundCus: value, isRateChange: true }, () => {
      this.getCusGridCalculations();
    });
  }

  handleSpreadCusChange = (event) => {
    var pattern = '^[0-9]+\.?[0-9]{0,' + utils.spreadDecimalPlaces + '}$';
    const re = new RegExp(pattern);
    if (event.target.value === '' || re.test(event.target.value)) {
      this.setState({ spreadCustom: event.target.value }, () => {
        //    this.getCusGridCalculations();
      })
    }
  }

  handleNegativeInterestRateChange = (value) => {
    console.log('-v changed to ' + value);
    utils.sendGaAnalyticsEvent(GA_OBJECTS_DIMENSIONS.negativeInterestRateTypes, value);
    this.setState({ negativeInterestType: value, isRateChange: true }, () => {
      this.getCusGridCalculations();
    });
  }


  handleFloorLvlChange = (event) => {
    const re = /^[0-9]+\.?[0-9]*$/;
    if (event.target.value === '' || re.test(event.target.value)) {
      this.setState({ floorLvl: event.target.value }, () => {
        //    this.getCusGridCalculations();
      })
    }
  }

  handleNegativeRateChange = (event) => {

  }

  // thousand separator changes
  numberWithCommas = (x) => {
    if (x === 'N/A')
      return x;
    else
      return (parseFloat(x).toLocaleString('en') !== 'NaN' ? parseFloat(x).toLocaleString('en') : "")
  }
  handleNotionalCusChange = (event) => {
    let notional = event.target.value;
    const rgx_thousand_number = /^[0-9,]+\.?[0-9]*$/;
    const rgx_zero_decimal = /\.[0]*$/;
    if (notional === '' || rgx_thousand_number.test(notional)) {
      if (!rgx_zero_decimal.test(notional)) {
        notional = notional.replace(/,/g, '');
        notional = this.numberWithCommas(notional)
      }
      this.setState({ notionalCustom: notional }, () => {
        //    this.getCusGridCalculations();
      })
    }
  }
  // thousand separator changes

  calcCoupon = (e) => {
    this.getCusGridCalculations();
  }

  keyPressCoupon = (e) => {
    if (e.keyCode == 13) {
      this.getCusGridCalculations();
    }
  }


  handleIndexDateChange = (value) => {
    utils.sendGaAnalyticsEvent(GA_OBJECTS_DIMENSIONS.indexDate, utils.formatDateDDMMYYY(value));
    this.setState({ endDateIndex: new Date(value) }, () => {
      this.getIndexRate();
    })
  }
  getCalculations = (e) => {
    e.preventDefault();
    this.getGridOneCalcs(false);
  }
  getGridOneCalcs = (isRealRate) => {
    if (isRealRate) {
      this.setState({ loadingFirstGridRealRate: _.clone(utils.loadArrTrue) })
    }
    else {
      this.setState({ loadingFirstGrid: _.clone(utils.loadArrTrue) })
    }

    const self = this;

    utils.periods.forEach(item => {

      if (isRealRate) {
        if (typeof sourceTokenRR[item] !== typeof undefined) {
          sourceTokenRR[item].cancel('new request')
        }
        sourceTokenRR[item] = axios.CancelToken.source();
      }
      else {
        if (typeof sourceTokenLag[item] !== typeof undefined) {
          sourceTokenLag[item].cancel('new request')
        }
        sourceTokenLag[item] = axios.CancelToken.source();
      }

      const url = utils.createGridOneUrl(this.state.instrumentType, this.state.endDate, item, isRealRate ? 0 : this.state.lag, this.state.defaultResetType);
      var tokens = Object.assign({},
        { cancelToken: isRealRate ? sourceTokenRR[item].token : sourceTokenLag[item].token },
        this.getHeaderWithToken())
      axios.get(url, tokens).then(res => {
        if (isRealRate) {
          let oldVal = _.clone(self.state.outputVal2)
          oldVal[item] = res.data;
          let isGridOneErr = self.state.isGridOneRealRateError
          isGridOneErr[item] = false;
          let loadingFirstGridRR = self.state.loadingFirstGridRealRate
          loadingFirstGridRR[item] = false;
          self.setState({ outputVal2: oldVal, isGridOneRealRateError: isGridOneErr, loadingFirstGridRealRate: loadingFirstGridRR });
        }
        else {
          let oldVal = _.clone(self.state.outputVal)
          oldVal[item] = res.data;
          let isGridOneErr = self.state.isGridOneError
          isGridOneErr[item] = false;
          let loadingFirstGrid = self.state.loadingFirstGrid
          loadingFirstGrid[item] = false;
          self.setState({ outputVal: oldVal, isGridOneError: isGridOneErr, loadingFirstGrid });
        }

      }).catch(err => {
        if (err && err.message !== "new request") {
          if (isRealRate) {
            let isGridOneErr = self.state.isGridOneRealRateError
            isGridOneErr[item] = true;
            let loadingFirstGridRR = self.state.loadingFirstGridRealRate
            loadingFirstGridRR[item] = false;
            self.setState({ isGridOneRealRateError: isGridOneErr, loadingFirstGridRealRate: loadingFirstGridRR });
          }
          else {
            let isGridOneErr = self.state.isGridOneError
            isGridOneErr[item] = true;
            let loadingFirstGrid = self.state.loadingFirstGrid
            loadingFirstGrid[item] = false;
            self.setState({ isGridOneError: isGridOneErr, loadingFirstGrid })
          }
        }
      })
    })
  }
  getGridOneFallbackCalcs = () => {

    this.setState({ loadingFirstGridFallbackRate: _.clone(utils.loadArrTrue) })
    const self = this;

    utils.periods.forEach(item => {
      const url = utils.createGridOneFallbackUrl(this.state.instrumentType, this.state.calcDate, item);
      axios.get(url).then(res => {

        let oldVal = _.clone(self.state.outputVal2)
        oldVal[item] = res.data;
        let isGridOneErr = self.state.isGridOneFallbackRateError
        isGridOneErr[item] = false;
        let loadingFirstGridFR = self.state.loadingFirstGridFallbackRate
        loadingFirstGridFR[item] = false;
        self.setState({ outputVal2: oldVal, isGridOneFallbackRateError: isGridOneErr, loadingFirstGridFallbackRate: loadingFirstGridFR });
        if (self.state.todaysFallbackDate == 'N/A' && res.data.today_date)
          self.setState({ todaysFallbackDate: res.data.today_date })

      }).catch(err => {
        if (err && err.message !== "new request") {
          let isGridOneErr = self.state.isGridOneFallbackRateError
          isGridOneErr[item] = true;
          let loadingFirstGridFR = self.state.loadingFirstGridFallbackRate
          loadingFirstGridFR[item] = false;
          self.setState({ isGridOneFallbackRateError: isGridOneErr, loadingFirstGridFallbackRate: loadingFirstGridFR });
        }
      })
    })
  }
  getCusCalculation = (e) => {
    e.preventDefault();
    this.getCusGridCalculations();
  }

  validateInputs = () => {
    if (this.state.instrumentType === "TONAR") {
      if (!utils.ValidateInteger(this.state.notionalCustom))
        return false;
    }
    return true;
  }

  getCusGridCalculations = () => {

    if (!this.validateInputs())
      return;

    var url = utils.createCustomFilterUrl(this.state.instrumentType, this.state.startDateCustom, this.state.endDateCustom,
      this.state.roundCus, this.state.lagCus, this.state.notionalCustom, this.state.spreadCustom,
      this.state.dayCount, this.state.endDateAdjustment, this.state.roundingRule,
      this.state.selectedHolidays, this.state.resetType, this.state.defaultEndDateAdjustment, this.state.defaultDayCount, this.state.defaultRoundingRule, this.state.defaultResetType, this.state.negativeInterestType, this.state.floorLvl);

    if (this.state.isRateChange == true) {
      this.setState({ loadingSecondRateGrid: true, isRateChange: false })
    }
    this.setState({ loadingSecondGrid: true })

    if (typeof sourceToken !== typeof undefined) {
      sourceToken.cancel('new request')
    }
    sourceToken = axios.CancelToken.source();

    var tokens = Object.assign({},
      { cancelToken: sourceToken.token },
      this.getHeaderWithToken())
    axios.get(url, tokens).then(res => {
      this.setState({ outputValCustom: res.data, isGridTwoError: false, loadingSecondGrid: false, loadingSecondRateGrid: false, isRateChange: false });
    }).catch(err => {
      if (err && err.message !== "new request")
        this.setState({ isGridTwoError: true, loadingSecondGrid: false, loadingSecondRateGrid: false, isRateChange: false })
    });
  }
  getIndexRate = () => {
    this.setState({ loadingIndex: true })

    var urls = utils.indexPeriods.map(item => {
      return utils.createIndexRateUrl(this.state.instrumentType, this.state.endDateIndex, item);
    });

    var promises = urls.map(item => {
      return axios.get(item, this.getHeaderWithToken());
    });

    return Promise.all(promises).then(resArray => {
      let oldVal = _.clone(this.state.index)
      resArray.forEach((item, index) => {
        oldVal[index === 0 ? '0D' : '5D'] = item.data;
      });
      this.setState({ index: oldVal, isLoadIndexError: false, loadingIndex: false });
    }).catch(err => {
      this.setState({ isLoadIndexError: true, loadingIndex: false })
    });
  }
  redirect = (path) => {
    this.props.history.push("/" + path);
  }
  copyLinkToExcelView = () => {
    let copyText = document.getElementById("myInput");
    copyText.style.display = "inline";
    copyText.select();
    document.execCommand("copy");
    copyText.style.display = "none";
    this.setState({ isAlertOpen: true });
    setTimeout(() => { this.setState({ isAlertOpen: false }) }, 2500);
  }

  onSignInClick = () => {
    this.props.history.push('/SignIn');
  }

  onRegisterClick = () => {
    this.props.history.push('/Register');
  }

  showOptions = () => {
    this.setState({ showAdvanceOptions: !this.state.showAdvanceOptions })
  }

  handleDayCountConventionChange = (value) => {
    utils.sendGaAnalyticsEvent(GA_OBJECTS_DIMENSIONS.dateCountConvention, value);
    this.setState({ dayCount: value, isRateChange: true }, () => {
      this.getCusGridCalculations();
    })
  }

  handleEndDateAdjustmentChange = (value) => {
    utils.sendGaAnalyticsEvent(GA_OBJECTS_DIMENSIONS.endDateAdjustment, value);
    this.setState({ endDateAdjustment: value, isRateChange: true }, () => {
      this.getCusGridCalculations();
    })
  }

  handleCouponRoundingRuleChange = (value) => {
    utils.sendGaAnalyticsEvent(GA_OBJECTS_DIMENSIONS.couponRoundingRule, value);
    this.setState({ roundingRule: value, isRateChange: true }, () => {
      this.getCusGridCalculations();
    })
  }

  handleHolidaysChange = (value) => {
    utils.sendGaAnalyticsEvent(GA_OBJECTS_DIMENSIONS.PaymentHolidays, value);
    this.setState({ selectedHolidays: value, isRateChange: true }, () => {
      this.getCusGridCalculations();
    })
  }

  handleResetTypeChange = (value) => {
    utils.sendGaAnalyticsEvent(GA_OBJECTS_DIMENSIONS.resetType, value);
    this.setState({ resetType: value, isRateChange: true }, () => {
      this.getCusGridCalculations();
    })
  }

  renderFallbackToggle = () => {
    return (<Toggle
      caption={this.state.fallbackToggle == false ? 'Show estimated fallbacks' : 'Hide estimated fallbacks'}
      toggleState={this.state.fallbackToggle}
      toggleHandler={this.handleFallbackToggle}
    />);
  }

  renderFixedPeriodFootNotes = () => {
    return (
      <div>
        {
          // this.state.instrumentType == 'SONIA' && !this.props.isAuthenticated ?
          //   <div className="row small ml-15">
          //     <span><sup className="redText">*</sup></span>
          //     <span className='text-gray'><a onClick={this.onRegisterClick}>Register</a> to see latest ON rate </span>
          //   </div> : null
        }
        <div className="row small ml-15">
          <span><sup className="redText">1</sup></span>
          <span className='text-gray'>date adjusted using 'Modified Following' rule</span>
        </div>

        {
          (this.state.fallbackToggle) ?
            <div className="row small ml-15">
              <span><sup className="redText">2</sup></span>
              <span className='text-gray'>Fallback spread using 5 year median lookback method <a onClick={() => { this.redirect('Fallback') }}>(more info)</a></span>
            </div> : null
        }
        <br />
      </div>
    );
  }

  renderBottomText = (type) => {
    switch (type) {
      case 'SONIA':
        return (
          this.props.isFirebaseEnabled ? (!this.props.isAuthenticated ? <div className="col-md-12 text-center information">
            <br /><span><sup className="redText">*</sup></span>The Bank of England publishes the SONIA benchmark on its <a target="_blank" href="http://www.bankofengland.co.uk/boeapps/iadb/fromshowcolumns.asp?html.x=yes&Datefrom=01/Jan/2011&Dateto=NOW%20&SeriesCodes=IUDSOIA&UsingCodes=Y&VPD=Y&VFD=N">historical database</a> at 10 am GMT on the business day after it is first published. Most recent data available under Bank of England's historical database for calculator is <b>{utils.formatDateDDMMYYY(this.state.lastFixingDate)}</b>, beyond that rate shows as N/A. You can  <a onClick={this.onSignInClick} title='Sign-in to view latest data.'> Sign-in </a>|<a onClick={this.onRegisterClick} title='Register to view latest data.'> Register </a>  to view the latest data published by Bank of England on <b>{utils.formatDateDDMMYYY(this.state.availableLastFixingDate)}</b>
            <br /><br />
          </div> : <div className="col-md-12 text-center information">
            <br />The calculator is using the most recent data published by Bank of England on <b>{utils.formatDateDDMMYYY(this.state.lastFixingDate)}</b> under <a href={pdfFile} target='_blank' rel="noopener noreferrer">Terms & Conditions</a> accepted by you during Registration, beyond that rate shows as N/A.<br /><br />
          </div>) : <div className="col-md-12 text-center information"><br />
            The Bank of England publishes the SONIA benchmark on its <a target="_blank" href="http://www.bankofengland.co.uk/boeapps/iadb/fromshowcolumns.asp?html.x=yes&Datefrom=01/Jan/2011&Dateto=NOW%20&SeriesCodes=IUDSOIA&UsingCodes=Y&VPD=Y&VFD=N">historical database</a> at 10 am GMT on the business day after it is first published. Most recent data available for calculator is <b>{utils.formatDateDDMMYYY(this.state.lastFixingDate)}</b>, beyond that rate shows as N/A.
            <div>
                <br /><br />
                <span style={{ color: 'red', fontWeight: 'bold' }}>
                    Please note that this website will be decommissioned on 1st June 2025.
                    After this date the site will no longer be available. We recommend you consider alternative
                    sites that provide compounded rate calculations such as <u><a href="https://www.spglobal.com/market-intelligence/en/solutions/products/rfr-calculator">S&P Global RFR Calculator</a></u> or the <u><a href="https://www.ice.com/report/244">ICE RFR Portal</a></u>.
                </span>
            </div>
        </div>
        );
      case 'SOFR':
        return <div className="col-md-12 text-center information">
          <br />The Federal Reserve Bank of New York publishes the SOFR benchmark on its <a target="_blank" href="https://apps.newyorkfed.org/markets/autorates/sofr">website</a> at 8 am EST each business day. Most recent data available for calculator is <b>{utils.formatDateDDMMYYY(this.state.lastFixingDate)}</b>, beyond that rate shows as N/A.  Use of SOFR is subject to NY Fed <a target="_blank" href="https://www.newyorkfed.org/markets/reference-rates-terms-of-use">Terms of Use</a>. <br /> <br />
            <div>
                <br /><br />
                <span style={{ color: 'red', fontWeight: 'bold' }}>
                    Please note that this website will be decommissioned on 1st June 2025.
                    After this date the site will no longer be available. We recommend you consider alternative
                    sites that provide compounded rate calculations such as <u><a href="https://www.spglobal.com/market-intelligence/en/solutions/products/rfr-calculator">S&P Global RFR Calculator</a></u> or the <u><a href="https://www.ice.com/report/244">ICE RFR Portal</a></u>.
                </span>
            </div>
        </div>;
      case '€STR':
        return <div className="col-md-12 text-center information">
          <br />The European Central Bank publishes the €STR benchmark on its <a target="_blank" href="https://www.ecb.europa.eu/stats/financial_markets_and_interest_rates/euro_short-term_rate/html/index.en.html">website</a> at 8:00 am CET each business day.  Most recent data available for calculator is <b>{utils.formatDateDDMMYYY(this.state.lastFixingDate)}</b> and earliest is <b>01 Oct 2019</b>, beyond that rate shows as N/A.  Use of €STR is subject to the ECB’s <a target="_blank" href="https://www.ecb.europa.eu/stats/financial_markets_and_interest_rates/euro_short-term_rate/html/index.en.html#disclaimer">€STR disclaimer</a> and general <a target="_blank" href="https://www.ecb.europa.eu/home/disclaimer/html/index.en.html">disclaimer & copyright statement</a>. <br /> <br />
            <div>
                <br /><br />
                <span style={{ color: 'red', fontWeight: 'bold' }}>
                    Please note that this website will be decommissioned on 1st June 2025.
                    After this date the site will no longer be available. We recommend you consider alternative
                    sites that provide compounded rate calculations such as <u><a href="https://www.spglobal.com/market-intelligence/en/solutions/products/rfr-calculator">S&P Global RFR Calculator</a></u> or the <u><a href="https://www.ice.com/report/244">ICE RFR Portal</a></u>.
                </span>
            </div>
          </div>;
      case 'TONAR':
        return <div className="col-md-12 text-center information">
          <br />The Bank of Japan publishes the TONAR benchmark on its <a target="_blank" href="http://www.stat-search.boj.or.jp/ssi/mtshtml/fm01_d_1_en.html">website</a> at 10:00 am JST each business day. Most recent data available for calculator is <b>{utils.formatDateDDMMYYY(this.state.lastFixingDate)}</b>, beyond that rate shows as N/A. Use of TONAR is subject to BoJ <a target="_blank" href="http://www.stat-search.boj.or.jp/info/notice_en.html">Terms of Use</a>
            <div>
                <br /><br />
                <span style={{ color: 'red', fontWeight: 'bold' }}>
                    Please note that this website will be decommissioned on 1st June 2025.
                    After this date the site will no longer be available. We recommend you consider alternative
                    sites that provide compounded rate calculations such as <u><a href="https://www.spglobal.com/market-intelligence/en/solutions/products/rfr-calculator">S&P Global RFR Calculator</a></u> or the <u><a href="https://www.ice.com/report/244">ICE RFR Portal</a></u>.
                </span>
            </div>
          </div>;
    }
  }

  render() {
    const alert_class = this.state.isAlertOpen ? '' : 'hidden-element';
    const instrumentType = this.state.instrumentType
    return (
      <div>
        {this.state.isBoeLoaded ?
          <div>
            <div className="row">
              <div className={"col-md-12 col-sm-8 col-xs-12 alert alert-info small " + alert_class}>
                Excel web query compatible link is copied to clipboard !
              </div>
              <div className='col-md-6 col-sm-8 col-xs-12'>
                <h6 className="header-title mb-0">{this.state.instrumentType} Realised Rates - Standard Tenors</h6>
              </div>
              {
                instrumentType ==='SONIA' ?
                this.props.isFirebaseEnabled &&
                <div className="col-md-6 col-sm-4 col-xs-12">
                  {!this.props.isAuthenticated && <div className="pull-right small text-purple register-sonia">
                  <a onClick={this.onSignInClick} title='Sign-in to view latest data. Please refer text at bottom for more information.'>Sign-in</a><span> | </span><a onClick={this.onRegisterClick} title='Register to view latest data. Please refer text at bottom for more information.'>Register</a><span><sup className="redText">*</sup></span>
                  </div>}
                </div>
                : null
              }
            </div>
            <FixedPeriodGrid
              outPut1={this.state.outputVal}
              outPut2={this.state.outputVal2}
              lag={this.state.lag}
              endDate={this.state.endDate}
              calcDate={this.state.calcDate}
              maxDate15={this.state.maxDate15}
              instrumentType={this.state.instrumentType}
              loadingFirstGridRealRate={this.state.loadingFirstGridRealRate}
              isGridOneRealRateError={this.state.isGridOneRealRateError}
              loadingFirstGridFallbackRate={this.state.loadingFirstGridFallbackRate}
              isGridOneFallbackRateError={this.state.isGridOneFallbackRateError}
              loadingFirstGrid={this.state.loadingFirstGrid}
              isGridOneError={this.state.isGridOneError}
              handleDateChange={this.handleDateChange}
              handleLagChange={this.handleLagChange}
              instrumentType={instrumentType}
              lagOptions={this.state.lagOptions}
              resetType={this.state.defaultResetType}
              fallbackMaxDate={this.state.fallbackMaxDate}
              fallbackMinDate={this.state.fallbackMinDate}
              calcDate={this.state.calcDate}
              handleFallbackDateChange={this.handleFallbackDateChange}
              fallbackToggle={this.state.fallbackToggle}
              todaysFallbackDate={this.state.todaysFallbackDate}
            />

            <div className="mt-1">
              {(instrumentType == 'SONIA' || instrumentType == 'SOFR') ?
                this.state.matches ?
                  <div className="row">
                    <div className="col-md-8">
                      {this.renderFixedPeriodFootNotes()}
                    </div>
                    <div className="col-md-4">
                      <div className="pull-right">
                        {(this.props.isFallbackEnabled) ? this.renderFallbackToggle() : null}
                      </div>
                    </div>
                  </div> :
                  <div>
                    <div className=" row">
                      <div className="col-md-8 col-sm-6 col-xs-2"></div>
                      <div className="col-md-4 col-sm-6 col-xs-10">
                        <div className="pull-right">
                          {(this.props.isFallbackEnabled) ? this.renderFallbackToggle() : null}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      {this.renderFixedPeriodFootNotes()}
                    </div>
                  </div>
                :
                // below will render plain old foot notes for ESTR and TONAR, once fallback is ready for ESTR ad TONAR we can completely kip if else.
                <div className="row">
                  {this.renderFixedPeriodFootNotes()}
                </div>
              }
            </div>

            <div className="row mt-4">
              <div className='col-md-12'>
                <h6 className="header-title">{this.state.instrumentType} Realised Rates - Rate & Payment Calculator</h6>
              </div>
            </div>
            <CustomPeriodControl
              startDateCustom={this.state.startDateCustom}
              endDateCustom={this.state.endDateCustom}
              outputValCustom={this.state.outputValCustom}
              lagCus={this.state.lagCus}
              roundCus={this.state.roundCus}
              spreadCustom={this.state.spreadCustom}
              floorLvl={this.state.floorLvl}
              notionalCustom={this.state.notionalCustom}
              holidays={this.state.holidays}
              maxDate15={this.state.maxDate15}
              loadingSecondGrid={this.state.loadingSecondGrid}
              loadingSecondRateGrid={this.state.loadingSecondRateGrid}
              isGridTwoError={this.state.isGridTwoError}
              showAdvanceOptions={this.state.showAdvanceOptions}
              handleStartDateCusChange={this.handleStartDateCusChange}
              handleEndDateCusChange={this.handleEndDateCusChange}
              handleLagCusChange={this.handleLagCusChange}
              handleRoundCusChange={this.handleRoundCusChange}
              handleSpreadCusChange={this.handleSpreadCusChange}
              handleNotionalCusChange={this.handleNotionalCusChange}
              showOptions={this.showOptions}
              calcCoupon={this.calcCoupon}
              keyPressCoupon={this.keyPressCoupon}
              loadingSecondRateGrid={this.state.loadingSecondRateGrid}
              dayCount={this.state.dayCount}
              endDateAdjustment={this.state.endDateAdjustment}
              roundingRule={this.state.roundingRule}
              handleDayCountConventionChange={this.handleDayCountConventionChange}
              handleEndDateAdjustmentChange={this.handleEndDateAdjustmentChange}
              handleCouponRoundingRuleChange={this.handleCouponRoundingRuleChange}
              handleHolidaysChange={this.handleHolidaysChange}
              instrumentType={instrumentType}
              roundOptions={this.state.roundOptions}
              lagOptions={this.state.lagOptions}
              endDateAdjustmentOptions={this.state.endDateAdjustmentOptions}
              roundingRuleOptions={this.state.roundingRuleOptions}
              dayCountOptions={this.state.dayCountOptions}
              holidayCalendarsOptions={this.state.holidayCalendarsOptions}
              defaultRoundingRule={this.state.defaultRoundingRule}
              defaultEndDateAdjustment={this.state.defaultEndDateAdjustment}
              defaultDayCount={this.state.defaultDayCount}
              currency={this.state.currency}
              defaultResetType={this.state.defaultResetType}
              resetType={this.state.resetType}
              resetTypeOptions={this.state.resetTypeOptions}
              handleResetTypeChange={this.handleResetTypeChange}
              negativeInterestRateTypes={this.state.negativeInterestRateTypes}
              defaultNegativeInterestRateType={this.state.defaultNegativeInterestRateType}
              negativeInterestType={this.state.negativeInterestType}
              handleFloorLvlChange={this.handleFloorLvlChange}
              handleNegativeInterestRateChange={this.handleNegativeInterestRateChange}
            />
            <br />
            <div className="form-row row">
              <div className='col-md-12'>
                <h6 className="header-title">{this.state.instrumentType} Realised Rates - RRIX Indices</h6>
              </div>
            </div>
            <IndexSection
              index={this.state.index}
              maxDate5={this.state.maxDate5}
              endDateIndex={this.state.endDateIndex}
              loadingIndex={this.state.loadingIndex}
              isLoadIndexError={this.state.isLoadIndexError}
              handleIndexDateChange={this.handleIndexDateChange}
              instrumentType={instrumentType}
            />
            <div className="row">
              <div className="col-md-12 small">
                <div title='Click to view Index details' className="pull-right text-purple">
                  <FaQuestionCircle />
                  <a onClick={() => { this.redirect('IndexDetails') }}>Index details</a>
                </div>
              </div>
            </div>
            {this.renderBottomText(instrumentType)}
          </div>
          : <div className="text-xs-center spinnerHome">
            <Loader className="loader" color='#6f2c91' scale={1.5} loaded={false} />
          </div>}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(User);




// WEBPACK FOOTER //
// ./src/components/User.js